module.exports = __webpack_public_path__ + "img/re.678ffd1c.png";